import { render, staticRenderFns } from "./UpdatePatientTaxDataForm.vue?vue&type=template&id=3114166e&scoped=true"
import script from "./UpdatePatientTaxDataForm.vue?vue&type=script&lang=js"
export * from "./UpdatePatientTaxDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3114166e",
  null
  
)

export default component.exports